<template>
  <div style=" padding: 20px;">
    <div>
      <h3>司法全景</h3>
      <br />
      <Panorama />
    </div>
    <div>
      <h3>司法信息</h3>
      <JudicialInfo />
    </div>
    <div style="margin-bottom:16px;">
      <h3>裁判文书</h3>
      <Judgment />
    </div>
  </div>
</template>
<script>
import JudicialInfo from './components/JudicialInfo'
import Panorama from './components/Panorama'
import Judgment from './components/Judgment'
export default {
  components: {
    JudicialInfo,
    Panorama,
    Judgment,
  },
  data() {
    return {
      loading: true,
      visible: true,
      TIP_PAY_MONEY: '此接口收费，确定继续前往吗？',
    }
  },
  mounted() {
    //console.log(1)
    // const params = {
    //   //enterpriseName: this.$store.getters['app/company'].name
    //   enterpriseName: '合肥胜利精密科技有限公司'
    // }
    // this.handleOk(params)
  },
  methods: {
    handleOk(params) {
      this.$refs.child1 && this.$refs.child1._getPanorama(params)
      this.$refs.child2 && this.$refs.child2._getJusticeInfo(params)
      this.$refs.child3 && this.$refs.child3._getTableData(params)
    },
    handleCancel() {
      this.visible = false
      this.loading = true
    },
    loadingFalse() {
      this.loading = false
      this.visible = false
    },
  },
}
</script>
